import React from 'react';
import Header from 'cccisd-header';
import style from './style.css';

const Fortress = window.cccisd.fortress;

const NavBar = () => {
    return (
        <Header
            containerClassName="container-fluid"
            wrapperClassName={style.wrapper}
            logoClassName={style.logo}
            secondaryNavLinks="mainNav"
            showHomeAction={false}
            showAlertAction={false}
            showAdminAction={Fortress.isSuperUser()}
        />
    );
};

export default NavBar;
